import { useEffect } from "react";
import { useDefaultTheme } from "@/hooks/useSiteSettings";

/**
 * Applies the admin-configured default theme on first load,
 * but only when the visitor has no saved preference.
 */
const ThemeBootstrap = () => {
  const { data: defaultTheme } = useDefaultTheme();

  useEffect(() => {
    if (!defaultTheme) return;
    const saved = localStorage.getItem("emera-theme");
    if (saved === "light" || saved === "dark") return; // respect user choice
    if (defaultTheme === "light") {
      document.documentElement.classList.remove("dark");
    } else {
      document.documentElement.classList.add("dark");
    }
  }, [defaultTheme]);

  return null;
};

export default ThemeBootstrap;
